import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from  '@gtpl/shared-utils/error-messages';
import { WorkersController } from './workers.controller';
import { WorkersService } from './workers.service';
import { WorkerEntity } from './workers.entity';
import { WorkersRepository } from './workers-repository';


@Module({
  imports: [
    TypeOrmModule.forFeature([WorkerEntity]),
  ],
  controllers: [WorkersController],
  providers: [WorkersService,ApplicationExceptionHandler,WorkersRepository],
  exports:[WorkersService]
})
export class workerModule {}
